import { DatePicker } from 'antd';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import './index.css'

const CustomDatePicker = DatePicker.generatePicker(momentGenerateConfig);

const MomentDatePicker = ({value,placeholder,format,style,form}) => {
    return <CustomDatePicker 
    dropdownClassName="custom-dropdown"
    value={form.getFieldValue("dateTime")}
    placeholder="Select Date and Time"
    format={format}
  //  style={style}
    onChange={(value) => form.setFieldsValue({dateTime : value })}
    //showTime 
     />;
   
  };
  

export default MomentDatePicker;
